/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { SurveyModelMinimalUtrv } from '../../../model/surveyData';
import { generateUrl } from '../../../routes/util';
import { getStatusIcon, getStatusText, isUtrvAssuranceComplete, isUtrvAssuranceRejected } from '../../../utils/universalTrackerValue';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

export const ColumnStatusIcon = (props: ColumnCommonProps) => {
  const { question, surveyId, initiativeId } = props;

  const history = useHistory();
  if (!question.utrv) {
    return null;
  }

  const utrv = question.utrv;

  const getIcon = (utrv: Pick<SurveyModelMinimalUtrv, 'status' | 'assuranceStatus' | 'lastUpdated'>) => {
    if (!utrv) {
      return {
        icon: '',
        onClick: undefined,
        disabled: true,
        className: 'fixed-width',
        tooltip: undefined,
      }
    }

    const defaultIcon = {
      icon: getStatusIcon(utrv),
      onClick: undefined,
      disabled: true,
      className: 'fixed-width',
      tooltip: getStatusText(utrv),
    }

    if (isUtrvAssuranceComplete(utrv.assuranceStatus) || isUtrvAssuranceRejected(utrv.assuranceStatus)) {
      return {
        ...defaultIcon,
        className: `${isUtrvAssuranceComplete(utrv.assuranceStatus) ? 'assured' : 'assurance-disputed'} fixed-width`,
        disabled: false,
        onClick: () => history.push(
          generateUrl(ROUTES.COMPANY_TRACKER_SURVEY, { initiativeId, surveyId, page: 'assurance' })
        )
      };
    }

    return {
      ...defaultIcon,
      disabled: false,
      className: `${utrv.status} fixed-width`,
    };
  }

  const statusIcon = getIcon(utrv);

  return (
    <Column className='text-center' disabled={statusIcon.disabled} onClick={statusIcon.onClick} tooltip={statusIcon.tooltip}>
      <i className={`fa ${statusIcon.icon} ${statusIcon.className}`} />
    </Column>
  );
}
